<template>
  <div id="goods">
    <div class="comond_btn">
      <el-select v-model="paras.status" placeholder="请选择" @change="handleSearch">
        <el-option v-for="n in travelStatus" :key="n.key" :label="n.label" :value="n.value"></el-option>
      </el-select>
      <el-button @click="dialogVisible = true">添加闪屏页/启动图</el-button>
    </div>
    <template>
      <!-- 列表 -->
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="闪屏页/启动图">
          <template width="100" slot-scope="scope">
            <img style="width:75px;height:134px;border:none;" :src="scope.row.picUrl" />
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">{{ scope.row.createTime | formatTimer }}</template>
        </el-table-column>
        <el-table-column label="更新时间">
          <template slot-scope="scope">{{ scope.row.updateTime | formatTimer }}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleDetail(scope.$index, scope.row)">查看</el-button>
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            >{{publishStatus==='T'?'下架':'上架'}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!-- 添加dialog -->
    <div>
      <el-dialog
        title="添加闪屏页/启动图"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <el-form>
          <el-form-item label="启动图(750*1334)" :label-width="formLabelWidth" required>
            <el-upload
              class="avatar-uploader"
              :data="qiniu"
              action="https://upload-z0.qiniup.com"
              :show-file-list="false"
              :multiple="false"
              :before-upload="(file) => { return handleBeforeUpload(file, 'qidong') }"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'qidong') }"
            >
              <img v-if="imgUrl" :src="imgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handCancer()">取 消</el-button>
          <el-button type="primary" @click="handleSave()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 编辑广告dialog -->
    <div>
      <el-dialog
        title="编辑广告"
        :visible.sync="editDialogVisible"
        width="30%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <el-form :model="ruleForm">
          <el-form-item label="广告图(750*300)" :label-width="formLabelWidth">
            <el-upload
              class="avatar-uploader"
              :data="qiniu"
              action="https://upload-z0.qiniup.com"
              :show-file-list="false"
              :multiple="false"
              :before-upload="(file) => { return handleBeforeUpload(file, 'qidong') }"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'qidong') }"
            >
              <img v-if="imgUrl" :src="imgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleEditCancle() ">取 消</el-button>
          <el-button type="primary" @click="handleEditSubmit()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 查看广告dialog -->
    <div>
      <el-dialog :visible.sync="detaildialogVisible" width="22%" top="5vh">
        <!-- 详情内容 -->
        <el-descriptions
          class="margin-top"
          direction="vertical"
          title
          :column="1"
          :size="size"
          border
        >
          <el-descriptions-item>
            <template slot="label">闪屏页/启动图</template>
            <el-image style="width: 375px; height: 667px" :src="detailData.picUrl"></el-image>
          </el-descriptions-item>
        </el-descriptions>

        <span slot="footer" class="dialog-footer">
          <el-button @click="detaildialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="detaildialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { qiniuupload, queryIndex, addIndex, createStartupDiagram, addCreateStartupDiagram, updateCreateStartupDiagram } from '../../api'
import moment from 'moment'
export default {
  data () {
    return {
      paras: {
        status: 1,
      },
      travelStatus: [ // 状态列表
        {
          value: 1,
          label: '已上架'
        },
        {
          value: 0,
          label: '已下架'
        }
      ],
      publishStatus: 'T',
      size: '',
      detailData: [],
      imgUrl: '',//解决图片回显问题
      uploadUrl: '', //  七牛上传地址前缀
      qiniu: { //  qiniu
        token: '',
        key: ''
      },
      formLabelWidth: '160px',
      // 添加广告默认关闭弹框
      dialogVisible: false,
      // 详情弹框
      detaildialogVisible: false,
      // 编辑弹框
      editDialogVisible: false,
      // 列表数据
      tableData: [],
      ruleForm: {
        id: '',
      }
    }
  },
  filters: {

    formatTimer: function (value) {
      if (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      } else {
        return "/"
      }

    }
  },

  methods: {
    // 上下架选择
    handleSearch (index) {
      console.log(index);
      // this.publishStatus = index
      if (index === 1) {
        this.publishStatus = 'T'
      } else {
        this.publishStatus = "F"
      }
      this.queryIndex()
    },
    handCancer () {
      this.dialogVisible = false
      this.imgUrl = ''
    },
    // 添加启动图确定提交
    handleSave () {
      let para = new URLSearchParams()
      para.append('picUrl', this.imgUrl)
      //请求接口
      addCreateStartupDiagram(para).then(data => {
        console.log(data);
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          //关闭弹窗
          this.dialogVisible = false
          this.imgUrl = ''
          this.queryIndex()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    // 七牛部分
    getToken () {
      let para = new URLSearchParams()
      para.append('bucket', 'productpic')
      qiniuupload(para).then((res) => {
        this.qiniu.token = res.data.token
        this.uploadUrl = res.data.bucketUrl
      })
    },
    handleOnSuccess (response, file, fileList, obj) { //  上传成功之后

      this.imgUrl = this.uploadUrl + '/' + response.key
    },
    handleBeforeUpload (file, obj) { //  上传之前
      this.qiniu.key = obj + `${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    //查看
    handleDetail (index, row) {
      this.detaildialogVisible = true
      this.detailData = row
    },
    // 编辑点击事件
    handleEdit (index, row) {
      console.log(index, row);
      this.editDialogVisible = true
      this.imgUrl = row.picUrl
      this.ruleForm.id = row.id
    },
    //编辑取消
    handleEditCancle () {
      this.editDialogVisible = false
      this.imgUrl = ''
    },
    // 编辑提交
    handleEditSubmit () {
      let para = new URLSearchParams()
      para.append('id', this.ruleForm.id)
      para.append('picUrl', this.imgUrl)
      para.append("isValid", this.publishStatus)
      updateCreateStartupDiagram(para).then(data => {
        // console.log(data);
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.editDialogVisible = false
          this.queryIndex()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    // 删除
    handleDelete (index, row) {
      // row  当前点击条目
      console.log(row);
      if (this.publishStatus === 'T') {
        console.log(111);
        if (this.tableData.length === 1) {
          this.$message({
            message: '只有一条数据了，不能下架，必须大于等两条数据才可以下架',
            type: 'error'
          })
        } else {
          let para = new URLSearchParams()
          para.append("id", row.id)
          para.append('picUrl', row.picUrl)
          para.append("isValid", 'F')
          updateCreateStartupDiagram(para).then(data => {
            if (data.code === 10000) {
              this.$message({
                message: data.msg,
                type: 'success'
              })
              this.queryIndex()
            } else {
              this.$message({
                message: data.msg,
                type: 'error'
              })
            }
          })
        }
      } else {
        console.log(222);
               let para = new URLSearchParams()
          para.append("id", row.id)
          para.append('picUrl', row.picUrl)
          para.append("isValid", 'T')
          updateCreateStartupDiagram(para).then(data => {
            if (data.code === 10000) {
              this.$message({
                message: data.msg,
                type: 'success'
              })
              this.queryIndex()
            } else {
              this.$message({
                message: data.msg,
                type: 'error'
              })
            }
          })
      }

    },
    // 查询列表
    queryIndex () {
      let para = new URLSearchParams()
      //   para.append('pageIndex', this.currentpageIndex)
      //   para.append('pageSize', this.currentpageSize)
      para.append('isValid', this.publishStatus)
      //请求接口
      createStartupDiagram(para).then(data => {
        console.log(data);
        if (data.code === 10000) {
          this.tableData = data.data
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
  },
  //生命周期
  mounted () {
    this.queryIndex()
    // 获取七牛token
    this.getToken()
  }
}

</script>
<style lang="stylus">
#goods {
  .comond_btn {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;

    button {
      background-color: #0a3d5f;
      color: #fff;
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
